var exports = {
  "r3": "dialog__uPI0uX",
  "v5": "dialogBody__RnMJky",
  "$y": "helpIcon__y9cU8o",
};

module.exports = exports;
